import Vue from 'vue'

Vue.filter('resize', (image, size = '') => {
	if (typeof image !== 'undefined') {
    if (image.startsWith('https://speelprojecten.b-cdn.net/a.storyblok.com')) {
      const [width, height] = size.split('x').filter(x => parseInt(x));
      const params = new URLSearchParams();

      if (width && height) {
        params.append('aspect_ratio',`${width}:${height}`);
      }

      if (width) {
        params.append('width', width);
      }
      if (height) {
        params.append('height', height);
      }

      const queryString = params.toString()

      return `${image}${queryString ? `?${queryString}` : ''}`;
    }

		return '//img2.storyblok.com/' + size + '/smart' + (image.replace('//a.storyblok.com', '').replace('https:', ''));
	}
	return null;
})

Vue.filter('transform', (image, options) => {
  if (image.startsWith('https://speelprojecten.b-cdn.net/a.storyblok.com')) {
    const params = new URLSearchParams();

    if (options) {
      const [width, height] = options.split('/')?.[0]?.split('x')?.filter(x => parseInt(x));

      const format = /format\(([^)]*)/.exec(options)?.[1];
      if (format) {
        params.append('format', format);
      }

      const quality = /quality\(([^)]*)/.exec(options)?.[1];
      if (quality) {
        params.append('quality', quality);
      }

      if (width && height) {
        params.append('aspect_ratio',`${width}:${height}`);
      }

      if (width) {
        params.append('width', width);
      }

      if (height) {
        params.append('height', height);
      }
    }

    const queryString = params.toString()

    return `${image}${queryString ? `?${queryString}` : ''}`;
  }

  if (image.includes('img2.storyblok.com')) {
    return image;
  }

  if (typeof image !== 'undefined') {
    return '//img2.storyblok.com/' + options + (image.replace('//a.storyblok.com', '').replace('https:', ''));
  }

  return null;
})

Vue.filter('dashify', function(value) {
	if (typeof value === 'undefined') {
		return 'undefined'
	}

	let dashified = value.toString()
		.replace(/([A-Z])/g, ' $1')
		.trim()
		.toLowerCase()
		.replace(/[ _]/g, '-');

	return 'blok-' + dashified;
})

Vue.filter('data-size', (url, resized) => {
	if (url) {
    const index = url.startsWith('https://speelprojecten.b-cdn.net') ? 6 : (resized ? 6 : 5);

		let sizes = url.split('/')[index].split('x');
		sizes = sizes.filter(item => item);

		if (sizes && sizes.length === 2) {
			if (resized && !url.startsWith('https://speelprojecten.b-cdn.net')) {
				const width = url.split('/')[3].split('x')[0];

				sizes = [width, sizes[1] * (width / sizes[0])];
			}

			return `{"width": ${parseInt(sizes[0])}, "height": ${parseInt(sizes[1])}}`;
		}
	}

	return `{"width": 200, "height": 200}`;
});
